import { render } from "./Customization.vue?vue&type=template&id=bc68cf5c"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"
script.render = render

export default script